import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import segariLogo from '../../icons/segari-logo.png';
import styles from './Header.module.css';

const Header = (props) => {
    return <Navbar className={styles.navbar}>
        <Container fluid className={styles.container}>
            <div href="/" className={styles.logoContainer} >
                <div className="lh-1">
                    <a href="/">
                        <img 
                            src={segariLogo}
                            alt={"Segari"}
                            height="30"
                            className="d-inline-block align-top"
                        />
                    </a>
                </div>
            </div>
            <Nav activeKey={props.activeKey}>
                <Nav.Item>
                    <Nav.Link href="/">Registrasi</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link href="/check-status">Cek Status</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link href="/asn">ASN</Nav.Link>
                </Nav.Item>
            </Nav>
        </Container>
    </Navbar>
}

export default Header;